export const checkBlankSpace = (input) => {
  const blankSpaceValidator = /^ *$/;
  return blankSpaceValidator.test(input);
};
